// extracted by mini-css-extract-plugin
export var progressBar = "_l6-0";
export var progressBarInner = "_l6-1";